import { curryN, clone, equals } from 'ramda';
import React from 'react';
import { ajax } from 'jquery';
import autoBind from '../../modules/autoBind';
import Spinner from '../../modules/Spinner.jsx';
import NumberInput from '../../modules/numberInput.jsx';
import PersonalDataForm from './PersonalDataForm.jsx';
import Questionnaire1 from './Questionnaire1.jsx';
import Questionnaire2 from './Questionnaire2.jsx';
import logo from '../assets/logo.png';
import PrivacyPolicy from './PrivacyPolicy.jsx';

export default class Questionnaires extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);
    this.state = {
      windowWidth: window.innerWidth,
      savedAnswers: null,
      savedPersonalData: null,
      resource: null,
      age: 0,
      identityValidated: false,
    }

    this.handleChange = curryN(2, this.handleChange);
  }
  componentDidMount() {
    this.fetchQuestionnaire(this.props.resourceUrl);
    window.addEventListener('resize', this.handleResize);
  }
  componentWillReceiveProps(nextProps) {
    this.fetchQuestionnaire(nextProps.resourceUrl);
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }
  handleResize() {
    this.setState({ windowWidth: window.innerWidth });
  }
  handleLeave(event) {
    if (this.s)
    return 'Tienes cambios sin guardar.';
  }
  fetchQuestionnaire(url) {
    ajax(url)
    .success((resource) => this.setState({ resource, savedAnswers: clone(resource._embedded ? resource._embedded.answers : null), savedPersonalData: clone(resource._embedded ? resource._embedded.personalData : null) }))
    .fail(() => this.setState({ resource: 'not found' }));
  }
  render() {
    return (
      <div className='container' style={{ padding: '30px 0px' }}>
        {this.getContent()}
      </div>
    );
  }
  getContent() {
    if (this.state.resource === null) {
      return <Spinner />;
    }

    if (this.state.resource === 'not found') {
      return <div>No se encontró el cuestionario...</div>;
    }

    if (this.state.resource.expired) {
      return <div>El cuestionario ha expirado.</div>
    }

    return (
      <div>
        <If condition={this.state.resource.expiration && this.state.resource.stage < 3}>
          <div>
            <img width='120px' src={logo} />
            <div className='pull-right'>
              Fecha Límite: <b>{moment(this.state.resource.expiration).format('DD/MM/YYYY')}</b>
            </div>
          </div>
        </If>
        {this.renderQuestionnaire()}
      </div>
    )
  }
  renderQuestionnaire() {
    const smallScreen = this.state.windowWidth < 1200;
    const answers = this.state.resource._embedded.answers;
    const personalData = this.state.resource._embedded.personalData;
    const representative = this.state.resource._embedded.personalData.representative;

    const name = personalData.name;
    if (this.state.resource.stage === 0) {
      if (this.state.identityValidated === false) {
        return (
          <div>
            <center>
              <p>Buen día</p>
              <h1><b><u>{name.toUpperCase()}</u></b></h1>
              <p>Bienvenido(a) a</p>
              <p><b>Whitewater Teaming Tools</b></p>
              <p>Usted recibió la liga de acceso a esta plataforma</p>
              <p>por instrucciones de {representative}</p>
              <br/>
              <p>Por favor elija una de las siguiente opciones:</p>
              <br/>

              <div className='row'>
                <div className='col-xs-3 col-xs-offset-1' style={{ textAlign: 'right' }}>
                <button onClick={() => this.setState({ identityValidated: 1 })} style={{ margin: '5px' }} className="btn btn-success"><span style={{ visibility: 'hidden' }}>X</span></button>
                </div>
                <div className='col-xs-5' style={{ textAlign: 'left' }}>
                  <span><b>Sí soy {name}</b></span>
                  <div>Al señalar esta opción continuará con el cuestionario.</div>
                </div>
              </div>

              <br/>

              <div className='row'>
                <div className='col-xs-3 col-xs-offset-1' style={{ textAlign: 'right' }}>
                <button onClick={() => this.setState({ identityValidated: 2 })} style={{ margin: '5px' }} className="btn btn-info"><span style={{ visibility: 'hidden' }}>X</span></button>
                </div>
                <div className='col-xs-5' style={{ textAlign: 'left' }}>
                  <span><b>Sí soy {name}, pero no sé de qué se trata esto.</b></span>
                  <div>Al señalar esta opción usted saldrá del sistema y recibirá un correo de {representative} explicándole por qué recibió esta invitación.</div>
                </div>
              </div>
              
              <br/>

              <div className='row'>
                <div className='col-xs-3 col-xs-offset-1' style={{ textAlign: 'right' }}>
                <button onClick={() => this.setState({ identityValidated: 3 })} style={{ margin: '5px' }} className="btn btn-danger"><span style={{ visibility: 'hidden' }}>X</span></button>
                </div>
                <div className='col-xs-5' style={{ textAlign: 'left' }}>
                  <span><b>NO soy {name}</b></span>
                  <div>Al señalar esta opción saldrá del sistema y enviará una notificación a {representative}.</div>
                </div>
              </div>

            </center>
          </div>
        );
      } else if (this.state.identityValidated === 3) {
        return (<div>Se ha enviado una notificación al administrador. Disculpe las molestias.</div>);
      } else if (this.state.identityValidated === 2) {
        return (<div>Se ha enviado una notificación al administrador. Usted recibirá un correo explicando el motivo del cuestionario.</div>);
      } else if (this.state.identityValidated === 1) {
        return (<div className='privacy-policy'>
          {PrivacyPolicy}
          <div>
          <button type='button' className='btn btn-success btn-lg pull-right' onClick={this.handleSubmit(0)}>Aceptar</button>
          </div>
        </div> );
      }
    }

    if (this.state.resource.stage === 1) {
      return <PersonalDataForm canSave={!equals(this.state.savedPersonalData, personalData)} onSave={this.handlePersonalDataSave} value={personalData} onSubmit={this.handlePersonalDataSubmit} onChange={(data) => {
        this.state.resource._embedded.personalData = data;
        this.setState({ resource: this.state.resource });
      }}/>;
    }

    if (this.state.resource.stage === 2) {
      return <Questionnaire1 smallScreen={smallScreen} value={answers[0]} canSave={!equals(this.state.savedAnswers[0], answers[0])} onChange={this.handleChange(0)} onSave={this.handleSave(0)} onSubmit={this.handleSubmit(0)}/>
    }

    if (this.state.resource.stage === 3) {
      return <Questionnaire2 value={answers[1]} canSave={!equals(this.state.savedAnswers[1], answers[1])} onChange={this.handleChange(1)} onSave={this.handleSave(1)} onSubmit={this.handleSubmit(1)}/>;
    }

    if (this.state.resource.stage === 4) {
      return <center><h3><br /><br /><br /><br /><br /><br /><span className='glyphicon glyphicon-ok' style={{ color: 'green' }}></span> Los cuestionarios han sido completados.</h3></center>;
    }
  }
  putPersonalData(saveOnly) {
    return ajax({ url: this.state.resource._rels.personalData, method: 'PUT', data: { personalData: this.state.resource._embedded.personalData, save: saveOnly }})
  }
  handlePersonalDataSave() {
    this.putPersonalData(true)
    .success(() => {
      this.state.savedPersonalData = clone(this.state.resource._embedded.personalData);
      this.setState({ savedPersonalData: this.state.savedPersonalData });
    }).fail(() => {
      alert('Ocurrió un error al guardar las respuestas.');
    });
  }
  handlePersonalDataSubmit() {
    this.putPersonalData(false)
    .success(() => {
      this.state.resource.stage++;
      this.setState({ resource: this.state.resource });
    }).fail(() => {
      alert('Hubo un error al guardar las respuestas.');
    });
  }
  handleChange(qId, answers) {
    this.state.resource._embedded.answers[qId] = answers;
    this.setState({ resource: this.state.resource });
  }
  putAnswers(qId, saveOnly) {
    return ajax({ url: this.state.resource._rels.answers, method: 'PUT', data: JSON.stringify({ answers: this.state.resource._embedded.answers, save: saveOnly }), headers: { 'Content-Type': 'application/json' } })
  }
  handleSave(qId) {
    return () => {
      this.putAnswers(qId, true)
      .success(() => {
        this.state.savedAnswers[qId] = clone(this.state.resource._embedded.answers[qId]);
        this.setState({ savedAnswers: this.state.savedAnswers });  
      }).fail(() => {
        alert('No se pudieron guardar las respuestas.');
      });
    }
  }
  handleSubmit(qId) {
    return () => {
      this.putAnswers(qId, false)
      .success(() => {
        this.state.resource.stage++;
        this.setState({ resource: this.state.resource });
        window.scrollTo(0, 0);
      }).fail(() => {
        alert('Hubo un error al guardar las respuestas.');
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/App/questionnaires/Questionnaires.jsx